import React from 'react';
import { useNavigate } from 'react-router-dom';

const PasswordReset = () => {


  const navigate = useNavigate();


  return (
         <div>
      <h2>Change Password</h2>
    To securely change your password, you can click RESET and you will be:
    <ol>
      <li>logged out and presented with the IntelliFire login Button - Click it</li>
      <li>At the login prompt, click "Forgot your password?"</li>
      <li>Enter your email address and click "→ Submit"</li>
    </ol>
    


      <button  onClick={() => navigate('/logout')}>RESET</button>
      </div>
  );



}


export default PasswordReset;